import { render, staticRenderFns } from "./AddOrder.vue?vue&type=template&id=9ba0e790&scoped=true&"
import script from "./AddOrder.vue?vue&type=script&lang=js&"
export * from "./AddOrder.vue?vue&type=script&lang=js&"
import style0 from "./AddOrder.vue?vue&type=style&index=0&id=9ba0e790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba0e790",
  null
  
)

export default component.exports